import axios from 'axios'
const AUTH_URL = process.env.AUTH_URL
const client = axios.create({
  baseURL: AUTH_URL
})

const signIn = async ({ username, password }) => {
  const path = '/sign-in'
  let authenticatedClient
  try {
    const response = await client.post(path, {
      username,
      password
    })
    authenticatedClient = response.data
  } catch (e) {
    const message = e.response ? e.response.data : 'Ooops, ha ocurrido un error :c'
    throw new Error(message)
  }
  return authenticatedClient
}

const validateToken = async (token) => {
  const path = `/validate-token/${token}`
  let isValid
  try {
    const response = await client.get(path)
    isValid = response.data.isValid
  } catch (e) {
    console.error(e)
    isValid = false
  }
  return isValid
}

const forgotPassword = async ({ email }) => {
  const path = '/forgot-password'
  try {
    await client.post(path, { email })
  } catch (e) {
    const message = e.response ? e.response.data : 'Ooops, ha ocurrido un error :c'
    throw new Error(message)
  }
}

const resetPassword = async ({ password, token }) => {
  const path = '/reset-password'
  try {
    await client.post(path, { password, token })
  } catch (e) {
    const message = e.response ? e.response.data : 'Ooops, ha ocurrido un error :c'
    throw new Error(message)
  }
}

export {
  signIn,
  validateToken,
  forgotPassword,
  resetPassword
}



// WEBPACK FOOTER //
// ./src/api/auth.js